var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmContractGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 10.8C10.8 9.80589 11.6059 9 12.6 9H21.6C22.5942 9 23.4 9.80589 23.4 10.8V17.1H21.6V10.8H12.6V24.3H16.2V26.1H12.6C11.6059 26.1 10.8 25.2941 10.8 24.3V10.8Z",
    fill: "#008C15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3526 15.4897C29.745 15.7948 29.8157 16.3603 29.5105 16.7526L23.8364 24.0479C23.1717 24.9025 21.9084 24.9812 21.1428 24.2156L17.3637 20.4365C17.0122 20.085 17.0122 19.5152 17.3637 19.1637C17.7152 18.8122 18.285 18.8122 18.6365 19.1637L22.4156 22.9428L28.0897 15.6475C28.3948 15.2552 28.9603 15.1845 29.3526 15.4897Z",
    fill: "#008C15"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmContractGreen);
export default __webpack_public_path__ + "static/media/ConfirmContractGreen.29a9eb37d0ca8e9b102b74b1a3293add.svg";
export { ForwardRef as ReactComponent };